import React from "react";
import Validator from "../Utility/Validator";
import MUIStack from "@mui/material/Stack";
import MUIIconButton from "@mui/material/IconButton";
import MUITooltip from "@mui/material/Tooltip";
import MUIHelpOutlineIcon from "@mui/icons-material/HelpOutline";
export default class ReportSetting extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.state.settings = this.props.settings || {};
    this.state.validationIssues = this.validate();
  }

  componentDidUpdate(previousProps) {
    if (previousProps.settings !== this.props.settings) {
      this.setState({
        settings: this.props.settings || {},
      });
    }
  }

  /**
   * Validates the current settings and sends the settings and any validation
   * issues back through props.onSettingsChange.
   */
  validate() {
    const validationIssues = Validator.validate(
      this.state.settings,
      this.props.validationRules,
    );

    this.props.onSettingsChange(this.state.settings, validationIssues);

    return validationIssues;
  }

  /**
   * Updates state with the new setting and triggers a validation.
   *
   * @param {string} key The setting that changed.
   * @param {*} value The value of that setting.
   */
  handleSettingChange(key, value) {
    this.setState(
      (prevState) => ({
        settings: {
          ...prevState.settings,
          [key]: value,
        },
      }),
      () => {
        this.setState({
          validationIssues: this.validate(),
        });
      },
    );
  }

  render() {
    // Check if in read-only mode
    if (this.props.readOnly) {
      return this.renderReadOnly();
    }

    // Normal editable mode (existing code)
    return (
      <MUIStack
        direction="row"
        spacing={1}
        sx={{
          alignItems: "center",
        }}
      >
        <div>{this.renderContent()}</div>
        <div>{this.renderHint()}</div>
      </MUIStack>
    );
  }

  /**
   * Returns a hint icon with tooltip if hint is provided.
   * @param {string} hint
   * @returns {JSX.Element} A hint icon with tooltip if hint is provided.
   */
  renderHint() {
    const hint = this.props.hint;
    if (hint !== undefined && hint !== null && hint !== "") {
      return (
        <MUITooltip title={hint}>
          <MUIIconButton>
            <MUIHelpOutlineIcon
              sx={{ color: (theme) => theme.palette.info.main }}
            />
          </MUIIconButton>
        </MUITooltip>
      );
    }
  }

  /**
   * Render the Report Setting content. Defaults to empty; subclasses should override.
   */
  renderContent() {
    return null;
  }

  /**
   * Renders read-only summary of settings. Subclasses should override this
   * to provide a compact read-only view. Return null if no read-only view needed.
   *
   * @returns {JSX.Element|null} Read-only representation of current settings
   */
  renderReadOnly() {
    return null;
  }
}
